import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox } from "devextreme-react/check-box";
import { TextArea } from "devextreme-react/text-area";
import { FileUploader } from "devextreme-react/file-uploader";
import { Button } from "devextreme-react/button";
import QCP_API from "api/qcpApi";
import { Toast } from "devextreme-react/toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import INTAKE_API from "api/intakeApi";
import ApprovedBy from "@common-components/qcp-cards/ApprovedBy";
import Cookies from "js-cookie";
import CCP_API from "api/ccpAPi";
import {
  useDelete,
  useFetch,
  usePost,
  useUpdate,
} from "@hooks/useCcpApi";
import notify from "devextreme/ui/notify";
import { urlToFile } from "utils/helpers";
import "@common-components/cards/DarkCard.scss";
import { RadioGroup } from "devextreme-react";
import { useFetch as useQCPFetch } from "@hooks/useQcpApi";

export default function CCPEdit({ edit, id }) {
  const addCCP = usePost("add-ccp", CCP_API.CCP);

  const { data: approvedBY, loading: loadingApprove } = useQCPFetch(
    "approvedbyget",
    QCP_API.approvedBy
  );
  const updatecommentsMutation = useUpdate("update-comments", CCP_API.comments);
  const addCCPImages = usePost("add-ccp-images", CCP_API.images);
  const updateCCP = useUpdate("updateCCP", CCP_API.CCP);
  const deleteImageMutation = useDelete("updateCCP", CCP_API.deleteImage);
  const deleteDocumentMutation = useDelete("updateCCP", CCP_API.document);
  const [isEdit, setIsEdit] = useState(true);

  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded file objects with statuses
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const [selectedDocuments, setSelectedDocuments] = useState([]); // Store selected files
  const [uploadedDocuments, setUploadedDocuments] = useState([]); // Store uploaded file objects with statuses
  const [documentUploaderKey, setDocumentUploaderKey] = useState(0);
  const [comments, setComments] = useState([]); // Store comments
  const [newComments, setNewComments] = useState([]); // Store comments
  const [newComment, setNewComment] = useState(""); // Track input
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState([]);

  const [visible, setVisible] = useState(false); // Default visible
  const [toastMessage, setToastMessage] = useState(""); // Default message
  const [toastType, setToastType] = useState("error"); // Default error
  const currentDate = new Date().toISOString(); // Store ISO format for consistency
  const location = useLocation();

  const {
    data: statuses,
    isLoading: isStatusLoading,
    // refetch,
  } = useFetch("getStatus", CCP_API.getStatus);

  const {
    data: ccpEditData,
    loading: isccpEditLoading,
    refetch,
  } = useFetch("getsingleCCP", CCP_API.CCP, { CCPId: id });
  useEffect(() => {
    refetch();
  }, [id]);

  const handleDeleteComment = (commentID) => {
    setComments((prev) =>
      prev.filter((comment) => comment.commentID !== commentID)
    );
  };

  const getCCPImageFile = async () => {
    if (!ccpEditData?.data[0]?.ccpimage) return;

    const imagePromises = ccpEditData.data[0].ccpimage.map(
      async (image) =>
        await urlToFile(image.imageURL, image.imageURL?.split("/").pop())
    );

    const apiFiles = await Promise.all(imagePromises);
    console.log(apiFiles);
    setSelectedFiles(apiFiles);
  };
  const getCCPDocumentFile = async () => {
    if (!ccpEditData?.data[0]?.documents) return;

    const imagePromises = ccpEditData.data[0].documents.map(
      async (image) =>
        await urlToFile(image.documentURL, image.documentURL?.split("/").pop())
    );

    const apiFiles = await Promise.all(imagePromises);
    // console.log(apiFiles);
    setSelectedDocuments(apiFiles);
  };

  useEffect(() => {
    if (ccpEditData) {
      formik.setValues({
        // boxNo: ccpEditData?.data[0]?.boxNo,

        batchNo: ccpEditData?.data[0]?.batchNo,
        type: ccpEditData?.data[0]?.type,
        // licensePlate: ccpEditData?.data[0]?.licensePlate,
        // company: ccpEditData?.data[0]?.company,
        // driver: ccpEditData?.data[0]?.driver,
        // truckTemp: ccpEditData?.data[0]?.truckTemp,
        // truckClean: ccpEditData?.data[0]?.truckClean,
        performedBy: ccpEditData?.data[0]?.performedBy,
        description: ccpEditData?.data[0]?.description,
        approvedBy: ccpEditData?.data[0]?.approvedBy,
        noBrokenGlass: ccpEditData?.data[0]?.noBrokenGlass,
        noLooseMetalFragments: ccpEditData?.data[0]?.noLooseMetalFragments,
        status: ccpEditData?.data[0]?.status?.orderStatusId,
        // comments: ccpEditData.data[0]?.ccpcomments || [],
        // files: files,
      });
      setComments(ccpEditData.data[0]?.ccpcomments || []);
      setUploadedFiles(
        (ccpEditData.data[0]?.ccpimage || []).map((image) => ({
          name: image.imageURL.split("/").pop(),
          url: image.imageURL,
          status: "uploaded",
          id: image.imageID,
        }))
      );
      setUploadedDocuments(
        (ccpEditData.data[0]?.documents || []).map((document) => ({
          name: document.documentURL.split("/").pop(),
          url: document.documentURL,
          status: "uploaded",
          id: document.documentID,
        }))
      );
    }

    getCCPImageFile();
    getCCPDocumentFile();
  }, [ccpEditData]);

  const validationSchema = Yup.object({
    type: Yup.string().required("Test type is required"),

    batchNo: Yup.string().required("Batch number is required"),

    performedBy: Yup.string().required("Performed by is required"),
    approvedBy: Yup.string().required("Approved by is required"),

    noBrokenGlass: Yup.string().required("Broken glass is required"),

    noLooseMetalFragments: Yup.string().required("Metal fragment is required"),

    // knivesAtProductionStartUp: Yup.number().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       .min(0, "Must be 0 or greater")
    //       .required("Knives startup count is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // knivesAtProductionEnd: Yup.number().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       .min(0, "Must be 0 or greater")
    //       .required("Knives end count is required"),
    //   // .test(
    //   //   "knives-count-match",
    //   //   "Knives end must be less than or equal to startup",
    //   //   function (value) {
    //   //     return value <= this.parent.knivesAtProductionStartUp;
    //   //   }
    //   // ),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // scissorsAtProductionStartUp: Yup.number().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       .min(0, "Must be 0 or greater")
    //       .required("Scissors startup count is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // scissorsAtProductionEnd: Yup.number().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       .min(0, "Must be 0 or greater")
    //       .required("Scissors end count is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // knives: Yup.string().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       // .oneOf(["true", "false"], "Invalid value for knives")
    //       .required("Knives check is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // scissors: Yup.string().when("type", {
    //   is: "2",
    //   then: (schema) =>
    //     schema
    //       // .oneOf(["true", "false"], "Invalid value for scissors")
    //       .required("Scissors check is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    status: Yup.string().required("Batch number is required"),

    description: Yup.string().max(1000, "Description is too long").nullable(),
  });

  const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setVisible(true);
  };

  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      const currentDate = new Date().toISOString(); // Store ISO format for consistency
      const updatedComments = [
        ...comments,
        { commentText: newComment, createdDateUTC: currentDate },
      ];

      setComments(updatedComments);

      let tempcom = newComments;
      tempcom.push({ commentText: newComment, createdDateUTC: currentDate });
      setNewComments(tempcom);
      setNewComment(""); // Clear input
    }
  };

  const batchNum = localStorage.getItem("batchNum");

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      batchNo: "",
      // licensePlate: "",
      // company: "",
      // driver: "",
      // truckTemp: "",
      // truckClean: false,
      description: "",
      type: 1,
      performedBy: "",
      approvedBy: "",
      noBrokenGlass: false,
      noLooseMetalFragments: false,
      status: 109,
      // comments: [],
      // files: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log(values);
      setLoader(true);
      // return;
      await updateCCP.mutateAsync({
        params: { CCPId: id },
        data: values,
      });

      const originalImages = ccpEditData?.data[0]?.ccpimage || [];
      console.log("original Images", originalImages);
      const removedImages = originalImages.filter(
        (img) => !uploadedFiles.some((file) => file.id === img.imageID)
      );
      const originalDocuments = ccpEditData?.data[0]?.documents || [];
      console.log("original Images", originalDocuments);
      const removedDocuments = originalDocuments.filter(
        (document) =>
          !uploadedDocuments.some((file) => file.id === document.documentID)
      );

      if (removedImages.length > 0) {
        for (const img of removedImages) {
          try {
            await deleteImageMutation.mutateAsync({ ImageId: img.imageID });
          } catch (error) {
            console.error("Error deleting image:", error);
            showToast("error", "Failed to delete image");
          }
        }
      }
      if (removedDocuments.length > 0) {
        for (const doc of removedDocuments) {
          try {
            await deleteDocumentMutation.mutateAsync({
              DocumentId: doc.documentID,
            });
          } catch (error) {
            console.error("Error deleting image:", error);
            showToast("error", "Failed to delete image");
          }
        }
      }

      const newImages = selectedFiles.filter((file) => {
        const isalreadyUploaded = !uploadedFiles.some((data) => {
          const uploadedFileName = data.url.split(
            process.env.REACT_APP_API_BLOB_STORAGE_URL
          )[1];

          // return uploadedFileName.includes(file.name);
          return uploadedFileName === file.name;
        });
        return isalreadyUploaded;
      });

      console.log(selectedDocuments, "new docs");

      const newDocuments = selectedDocuments.filter((file) => {
        const isalreadyUploaded = !uploadedDocuments.some((data) => {
          const uploadedFileName = data.url.split(
            process.env.REACT_APP_API_BLOB_STORAGE_URL
          )[1];

          // return uploadedFileName.includes(file.name);
          return uploadedFileName === file.name;
        });
        return isalreadyUploaded;
      });

      // console.log(newDocuments,'new docs');

      // setLoader(false);
      // return;
      if (newImages.length > 0) {
        for (const file of newImages) {
          const formData = new FormData();
          formData.append("CCPId", id); // Attach qcp_id to each file
          formData.append("File", file); // Attach the file
          try {
            await imageUploadMutation.mutateAsync(formData);
            showToast("success", "Image uploaded successfully");
          } catch (error) {
            console.error("Error uploading image:", error);
            showToast("error", "Failed to upload image");
          }
        }
      }

      if (newDocuments.length > 0) {
        for (const file of newDocuments) {
          const formData = new FormData();
          formData.append("CCPId", id); // Attach qcp_id to each file
          formData.append("File", file); // Attach the file
          try {
            await documentUploadMutation.mutateAsync(formData);
            showToast("success", "Image uploaded successfully");
          } catch (error) {
            console.error("Error uploading image:", error);
            showToast("error", "Failed to upload image");
          }
        }
      }

      const originalComments = ccpEditData?.data[0]?.ccpcomments || [];
      const removedComments = originalComments.filter(
        (comment) => !comments.some((c) => c.commentID === comment.commentID)
      );
      const newComments = comments.filter(
        (comment) =>
          !originalComments.some((c) => c.commentID === comment.commentID)
      );
      const editedComments = comments.filter((comment) => {
        const originalComment = originalComments.find(
          (c) => c.commentID === comment.commentID
        );
        return (
          originalComment && originalComment.commentText !== comment.commentText
        );
      });

      const commentsPayload = {
        editCCPCommentsRequest: [
          ...removedComments.map((comment) => ({
            commentId: comment.commentID,
            ccP_ID: id,
            commentText: comment.commentText, // Keep the original text
            isDeleted: true,
            deletedDateUTC: new Date().toISOString(), // Add deleted date
          })),
          ...newComments.map((comment) => ({
            commentId: 0,
            ccP_ID: id,
            commentText: comment.commentText,
            isDeleted: false,
            deletedDateUTC: new Date().toISOString(), // Add deleted date
          })),
          ...editedComments.map((comment) => ({
            commentId: comment.commentID,
            ccP_ID: id,
            commentText: comment.commentText,
            isDeleted: false,
            deletedDateUTC: new Date().toISOString(), // Add deleted date
          })),
        ],
      };

      await updatecommentsMutation.mutateAsync({
        data: commentsPayload, // ✅ Send modified values
      });

      showToast("success", "CCP Data Saved Successfully");
      // navigate("/quality/fillet/ccp");
      // refetch();
      // refetch();
      setLoader(false);
      setIsEdit(true);
      setTimeout(() => {
        navigate("/quality/fillet/ccp");
        // setLoading(false); // Stop loading
      }, 2000);
    },
  });

  const imageUploadMutation = usePost(
    "uploadImages",
    CCP_API.images,
    "multipart/form-data"
  );
  const documentUploadMutation = usePost(
    "uploadDocuments",
    CCP_API.document,
    "multipart/form-data"
  );

  const handleUploadClick = () => {
    if (selectedFiles.length === 0) return;

    setUploadedFiles((prevFiles) =>
      prevFiles.map((file) => ({ ...file, status: "uploading" }))
    );

    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file); // ✅ Correctly appends the file
      formData.append("fileName", file.name); // ✅ Send plain file name
      formData.append("Length", file.size); // ✅ Send plain file size
    });

    imageUploadMutation.mutate(formData, {
      onSuccess: (uploadedData) => {
        setUploadedFiles((prevFiles) =>
          prevFiles.map((file) => ({
            ...file,
            status: "uploaded",
            uploadedData,
          }))
        );
      },
      onError: () => {
        console.log("getDeletedFile");
        setUploadedFiles((prevFiles) =>
          prevFiles.map((file) => ({ ...file, status: "error" }))
        );
        const getDeletedFile = uploadedFiles.find(
          (data) => data.status === "error"
        );
      },
    });
  };

  const handleFileChange = (e) => {
    const newFiles = e.value;

    // Filter out duplicates based on name and size
    const existingFilesMap = new Map(
      selectedFiles.map((file) => [`${file.name}-${file.size}`, file])
    );

    const uniqueNewFiles = newFiles.filter(
      (file) => !existingFilesMap.has(`${file.name}-${file.size}`)
    );

    const filePreviews = uniqueNewFiles.map((file) => ({
      name: file.name,
      size: file.size,
      url: URL.createObjectURL(file),
      status: "pending",
    }));

    setSelectedFiles([...selectedFiles, ...uniqueNewFiles]);
    setUploadedFiles([...uploadedFiles, ...filePreviews]);
  };
  const handleDocumentChange = (e) => {
    const newFiles = e.value;

    // Filter out duplicates based on name and size
    const existingFilesMap = new Map(
      selectedDocuments.map((file) => [`${file.name}-${file.size}`, file])
    );

    const uniqueNewFiles = newFiles.filter(
      (file) => !existingFilesMap.has(`${file.name}-${file.size}`)
    );

    const filePreviews = uniqueNewFiles.map((file) => ({
      name: file.name,
      size: file.size,
      url: URL.createObjectURL(file),
      status: "pending",
    }));

    setSelectedDocuments([...selectedDocuments, ...uniqueNewFiles]);
    setUploadedDocuments([...uploadedDocuments, ...filePreviews]);
  };

  const handleDeleteImage = (identifier, index) => {
    setUploadedFiles((prev) =>
      prev.filter((file) => file.id !== identifier && file.url !== identifier)
    );

    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setFileUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };
  const handleDeleteDocument = (identifier, index) => {
    setUploadedDocuments((prev) =>
      prev.filter((file) => file.id !== identifier && file.url !== identifier)
    );

    setSelectedDocuments((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setDocumentUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };

  // console.log(formik.errors)

  return (
    <>
      <Toast
        visible={visible}
        message={toastMessage}
        type={toastType}
        displayTime={2000}
        onHiding={() => setVisible(false)}
        position={{ my: "top right", at: "top right", offset: "10 10" }}
      />
      <div className="p-4 bg-gray-100 border rounded dark-bg">
        <div className="flex justify-end">
          <Button
            onClick={(e) => {
              if (e?.stopPropagation) e.stopPropagation(); // Safely prevent accordion toggle
              setIsEdit((prev) => !prev);
            }}
            // className="profile-edit-button"
            width={120}
            text={`${isEdit ? "Edit Record" : "View Record"}`} // Toggle text based on isEdit state
            stylingMode="contained"
            type="default"
          />
        </div>
        <div className="w-full flex items-center mt-3 lg:mt-0">
          {/* <p className="text-xl font-medium whitespace-break-spaces">Control Glass and Metal - Daily</p> */}

          <div className="flex-grow h-px bg-gray-300 ml-2 light-bg"></div>
        </div>
        <p>Test for broken glass or other fragile material incl. fragments</p>

        <form onSubmit={formik.handleSubmit}>
          <p className="font-medium text-xl">Truck Inspection</p>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-5 lg:space-y-0 space-y-3">
            <div className="border rounded border-gray-50 dark-bg p-4 custom-p-b-0">
              <div className="w-full flex items-center mb-2">
                <p className="whitespace-nowrap text-xl font-medium">
                  Add Info:
                </p>
                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              <div className="block lg:grid lg:grid-cols-2 space-y-4 lg:space-y-0 gap-4">
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Batch No.
                  </label>
                  <TextBox
                    disabled={isEdit}
                    placeholder="Enter Batch No..."
                    value={formik.values.batchNo}
                    onValueChange={(value) =>
                      formik.setFieldValue("batchNo", value.trim())
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.batchNo && formik.errors.batchNo && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {formik.errors.batchNo}
                    </div>
                  )}
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Description
                  </label>
                  <TextBox
                    disabled={isEdit}
                    placeholder="Enter Description"
                    value={formik.values.description}
                    onValueChange={(value) =>
                      formik.setFieldValue("description", value.trim())
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {formik.errors.description}
                    </div>
                  )}
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Performed by
                  </label>
                  <TextBox
                    disabled={true}
                    placeholder="Enter Name"
                    value={formik.values.performedBy}
                    onValueChange={(value) =>
                      formik.setFieldValue("performedBy", value.trim())
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.performedBy && formik.errors.performedBy && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {formik.errors.performedBy}
                    </div>
                  )}
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Approved by
                  </label>
                  <SelectBox
                    disabled={isEdit}
                    dataSource={approvedBY?.data || []}
                    displayExpr={(item) =>
                      item
                        ? item.firstName
                            .toLowerCase()
                            .split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" ")
                        : ""
                    } // Capitalize the first letter of each word
                    valueExpr="firstName"
                    value={formik.values.approvedBy}
                    onValueChanged={(e) =>
                      formik.setFieldValue("approvedBy", e.value)
                    }
                    isValid={
                      !(formik.errors.approvedBy && formik.touched.approvedBy)
                    }
                    validationError={
                      formik.errors.approvedBy
                        ? { message: formik.errors.approvedBy }
                        : null
                    }
                    placeholder="Select an option"
                  />
                </div>

                <div className="col-span-1">
                  <label className="relative">
                    Status{" "}
                    <span className="text-red-500 text-lg absolute top-[-4px]">
                      *
                    </span>
                  </label>
                  {statuses && statuses?.data && (
                    <SelectBox
                      disabled={isEdit}
                      dataSource={statuses?.data || []}
                      displayExpr="description"
                      valueExpr="orderStatusId"
                      value={formik.values.status} // Bind to formik's status value
                      // value={values.statusID}
                      onValueChanged={(e) => {
                        formik.setFieldValue("status", e.value);
                      }}
                    />
                  )}
                </div>
                <div></div>
                <div className="lg:col-span-2">
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    No broken glass / other fragments before startup:
                  </label>
                  <RadioGroup
                    disabled={isEdit}
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.noBrokenGlass}
                    onValueChanged={(e) =>
                      formik.setFieldValue("noBrokenGlass", e.value)
                    }
                    isValid={
                      !(
                        formik.errors.noBrokenGlass &&
                        formik.touched.noBrokenGlass
                      )
                    }
                    validationError={
                      formik.errors.noBrokenGlass
                        ? { message: formik.errors.noBrokenGlass }
                        : null
                    }
                  />
                </div>
                <div className="lg:col-span-2">
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    No loose metal fragments / parts before startup:
                  </label>
                  <RadioGroup
                    disabled={isEdit}
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.noLooseMetalFragments}
                    onValueChanged={(e) =>
                      formik.setFieldValue("noLooseMetalFragments", e.value)
                    }
                    isValid={
                      !(
                        formik.errors.noLooseMetalFragments &&
                        formik.touched.noLooseMetalFragments
                      )
                    }
                    validationError={
                      formik.errors.noLooseMetalFragments
                        ? { message: formik.errors.noLooseMetalFragments }
                        : null
                    }
                  />
                </div>
              </div>

              <div className="w-full flex items-center mt-4 mb-2">
                <p className="whitespace-nowrap text-xl font-medium">
                  Add Picture(s):
                </p>
                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
                {!isEdit && (
                  <FileUploader
                    key={fileUploaderKey}
                    multiple
                    accept=".png, .jpg, .jpeg, .jpg, .gif, .webp, .svg"
                    onValueChanged={handleFileChange}
                    showFileList={false}
                    // value={selectedFiles}
                  />
                )}
                {uploadedFiles.length > 0 && (
                  <ul className="grid lg:grid-cols-3 grid-cols-1 gap-4 mb-0 ps-0">
                    {uploadedFiles.map((file, index) => (
                      <li key={index} className="text-sm relative">
                        <img
                          src={file.url}
                          alt={file.name}
                          className="w-full h-24 object-cover rounded border"
                        />
                        <p className="text-xs text-center mt-1 break-words mb-0">
                          {file.name}
                        </p>
                        {!isEdit && (
                          <button
                            type="button"
                            className="absolute top-1 right-1 bg-red-600 text-white ml-10 text-xs rounded-full px-[7px] py-1"
                            onClick={() =>
                              handleDeleteImage(file.id || file.url, index)
                            }
                          >
                            ✕
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="w-full flex items-center mt-4 mb-2">
                <p className="whitespace-nowrap text-xl font-medium">
                  Add Attachment(s):
                </p>
                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
                {!isEdit && (
                  <FileUploader
                    key={documentUploaderKey}
                    multiple
                    accept=".pdf, .docx, .xlsx .doc, .pptx, .txt, .ppt, .xls, .csv, .zip, .rar"
                    onValueChanged={handleDocumentChange}
                    showFileList={false}
                    // value={selectedFiles}
                  />
                )}
                {uploadedDocuments.length > 0 && (
                  <ul className="space-y-2 ps-0 flex items-center justify-center flex-column mb-0">
                    {uploadedDocuments.map((file, index) => (
                      <li
                        key={index}
                        className="text-sm flex items-center space-x-2 rounded-md border p-2"
                      >
                        <span>{file.name}</span>
                        {!isEdit && (
                          <button
                            type="button"
                            className="text-red-700 text-xs rounded-full p-1"
                            onClick={() =>
                              handleDeleteDocument(file.id || file.url, index)
                            }
                          >
                            ✕
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="border rounded border-gray-50 dark-bg p-4 flex flex-col">
              {!isEdit && (
                <div className="w-full flex items-center mb-2">
                  <p className="whitespace-nowrap text-xl font-medium">
                    Add Comments:
                  </p>
                  <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                </div>
              )}
              <div className="max-h-full overflow-y-auto lg:pr-2 pr-0 custom-scrollbar space-y-2 mb-4">
                {comments?.map((comment, index) => (
                  <div
                    key={index}
                    className="bg-gray-100 hover:bg-gray-200 dark-bg hover:cursor-pointer rounded px-3 py-2 border"
                  >
                    <div className="flex flex-col justify-start ms-2">
                      <p className="font-medium mb-0">
                        {/* {comment?.commentedBy?.firstName
                        ? comment?.commentedBy?.firstName
                        : "" + " " + comment?.commentedBy?.lastName
                          ? comment?.commentedBy?.lastName
                          : ""} */}
                        {`${comment?.commentedBy?.firstName ? comment?.commentedBy?.firstName : ""} ${comment?.commentedBy?.lastName ? comment?.commentedBy?.lastName : ""}`}
                      </p>
                      <div className="flex items-center justify-end space-x-5">
                        <p className="text-xs mb-0 whitespace-nowrap mt-1">
                          {new Date(
                            comment.createdDateUTC || currentDate
                          ).toLocaleDateString("en-US")}
                        </p>
                        {!isEdit && (
                          <button
                            type="button"
                            className="text-red-700 ml-10 text-xs mt-1"
                            onClick={() =>
                              handleDeleteComment(comment.commentID)
                            }
                          >
                            ✕
                          </button>
                        )}
                      </div>
                    </div>
                    <p className="flex-grow mt-2 break-words">
                      {comment.commentText}
                    </p>
                  </div>
                ))}
              </div>
              {!isEdit && (
                <div className="mt-auto">
                  <TextArea
                    placeholder="Add comment..."
                    maxLength={123}
                    height={100}
                    stylingMode="outlined"
                    mode="multiline"
                    value={newComment} // Controlled input
                    onValueChanged={(e) => setNewComment(e.value)} // Only update newComment
                  />
                  <Button
                    className="mt-2"
                    icon="plus"
                    text="Add more comment"
                    stylingMode="text"
                    onClick={handleAddComment} // Call function on click
                  />
                </div>
              )}
            </div>
          </div>
          {!isEdit && (
            <div className="flex items-center justify-end mt-6">
              <Button
                className="me-3"
                width={100}
                text="Cancel"
                type="normal"
                stylingMode="outlined"
                onClick={() => {
                  navigate("/quality/fillet/ccp");
                }}
              />
              <Button
                width={100}
                text={loader ? "Saving" : "Save"}
                stylingMode="contained"
                type="default"
                disabled={loader}
                useSubmitBehavior
              />
            </div>
          )}
        </form>
      </div>
    </>
  );
}
